import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeChatActionModal } from '../../actions/chatActionModal';
import { deleteAllChats, removeChatFromSelected, deleteChats } from '../../actions/chatList';
import { ChatActionModal } from '../../components/ChatActionModal';
import { ESection } from '../../repositories/chats/v1/chats-bulk-operations-delete-all-from-section-desktop';
import { chatListSelector } from '../../selectors';
import { chatActionModalSelector } from '../../selectors/chatActionModalSelector';
import { EChatAction } from '../../types/chatActionModal';
import { ERoute } from '../../types/route';
import { EGroupActions, trackGroupActionClick } from '../ListActionButtonsContainer/tracking';

type TRoutesAvailableToChange = Exclude<ERoute, ERoute.Spam>;

const RouteToSectionMap = {
  [ERoute.Messages]: ESection.Main,
  [ERoute.Archive]: ESection.Archive,
  [ERoute.Unread]: ESection.Unread,
};

export const ChatActionModalContainer: React.VFC = () => {
  const dispatch = useDispatch();
  const { isOpened, buttonText, chatAction, text } = useSelector(chatActionModalSelector);
  const { isChangeListActive, selectedChats, currentRoute, chats } = useSelector(chatListSelector);

  const onCancel = React.useCallback(() => {
    // если не активна работа со списком чатов, чат выбран из контекстного меню
    if (!isChangeListActive) {
      dispatch(removeChatFromSelected(selectedChats[0]));
    }

    dispatch(closeChatActionModal());
  }, [dispatch, selectedChats, isChangeListActive]);

  const onConfirm = React.useCallback(() => {
    dispatch(closeChatActionModal());

    switch (chatAction) {
      case EChatAction.Delete:
        dispatch(deleteChats());

        return;

      case EChatAction.GroupDelete:
        if (selectedChats.length) {
          dispatch(deleteChats());
          trackGroupActionClick(
            EGroupActions.Delete,
            chats.filter(({ chatId }) => selectedChats.includes(chatId)),
          );

          return;
        }

        dispatch(deleteAllChats(RouteToSectionMap[currentRoute as TRoutesAvailableToChange]));
        trackGroupActionClick(EGroupActions.Delete);
    }
  }, [dispatch, chatAction, selectedChats, currentRoute, chats]);

  if (!isOpened) {
    return null;
  }

  return <ChatActionModal buttonText={buttonText} onCancel={onCancel} onConfirm={onConfirm} text={text} />;
};
